export const FETCH_START = 'FETCH_START';
export const FETCH_DONE = 'FETCH_DONE';

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export const ADD_VISITED_VIEWS = 'ADD_VISITED_VIEWS';
export const DEL_VISITED_VIEWS = 'DEL_VISITED_VIEWS';
export const DEL_OTHERS_VIEWS = 'DEL_OTHERS_VIEWS';
export const DEL_ALL_VIEWS = 'DEL_ALL_VIEWS';
